interface Props {
  line?: boolean
  title?: boolean
  infoPanel?: boolean
  table?: boolean
}

export const LoadingSkeleton = ({ line = false, title = false, infoPanel = false, table = false }: Props) => {
  return (
    <div className="flex flex-col gap-3 py-2">
      { line && <div className="bg-zinc-200 dark:bg-zinc-700 rounded-lg h-6 animate-pulse" /> }
      { title && <div className="bg-zinc-200 dark:bg-zinc-700 rounded-lg h-16 text-4x animate-pulse p-6" /> }
      { infoPanel && <div className="bg-zinc-200 dark:bg-zinc-700 rounded-lg h-24 animate-pulse p-6" /> }
      { table && <div className="flex flex-col gap-1.5">
        <div className="flex flex-row gap-1.5">
          <div className="bg-zinc-200 dark:bg-zinc-700 rounded-lg h-12 grow animate-pulse p-6" />
          <div className="bg-zinc-200 dark:bg-zinc-700 rounded-lg h-12 w-32 animate-pulse p-6" />
          <div className="bg-zinc-200 dark:bg-zinc-700 rounded-lg h-12 w-24 animate-pulse p-6" />
        </div>
        <div className="bg-zinc-200 dark:bg-zinc-700 rounded-lg h-96 animate-pulse p-6" />
      </div> }
    </div>
  )
}
